import { filterNonAstNodes } from '../parser';
import { nameLikeTokens } from '../parser/fns';
import { assert } from '../util/todo';
import { buildExpr } from './expr';
import { buildParam } from './index';
import { buildMatchExpr, buildNumber, buildPattern } from './match';
import { buildBlock, buildStatement } from './statement';
import { buildType } from './type';
export const buildOperand = (node) => {
    const n = filterNonAstNodes(node)[0];
    switch (n.kind) {
        case 'if-expr':
            return buildIfExpr(n);
        case 'if-let-expr':
            return buildIfLetExpr(n);
        case 'while-expr':
            return buildWhileExpr(n);
        case 'for-expr':
            return buildForExpr(n);
        case 'match-expr':
            return buildMatchExpr(n);
        case 'closure-expr':
            return buildClosureExpr(n);
        case 'expr':
            return buildExpr(n);
        case 'list-expr':
            return buildListExpr(n);
        case 'string':
            return buildString(n);
        case 'char':
            return buildChar(n);
        case 'number':
            return buildNumber(n);
        case 'bool':
            return buildBool(n);
        case 'identifier':
            return buildIdentifier(n);
    }
    throw Error(`expected operand, got ${node.kind}`);
};
export const identifierFromOperand = (operand) => {
    if (operand.kind === 'identifier')
        return operand;
    if (operand.kind === 'operand-expr') {
        return identifierFromOperand(operand.operand);
    }
    return undefined;
};
export const buildIfExpr = (node) => {
    const nodes = filterNonAstNodes(node);
    let idx = 0;
    // skip if-keyword
    idx++;
    const condition = buildExpr(nodes[idx++]);
    const thenBlock = buildBlock(nodes[idx++]);
    // skip else keyword
    idx++;
    const elseBlock = nodes.at(idx) ? buildBlock(nodes[idx++]) : undefined;
    return { kind: 'if-expr', parseNode: node, condition, thenBlock, elseBlock };
};
export const buildIfLetExpr = (node) => {
    const nodes = filterNonAstNodes(node);
    let idx = 0;
    // skip if and let keywords
    idx++;
    idx++;
    const pattern = buildPattern(nodes[idx++]);
    const expr = buildExpr(nodes[idx++]);
    const thenBlock = buildBlock(nodes[idx++]);
    // skip else keyword
    idx++;
    const elseBlock = nodes.at(idx) ? buildBlock(nodes[idx++]) : undefined;
    return { kind: 'if-let-expr', parseNode: node, pattern, expr, thenBlock, elseBlock };
};
export const buildWhileExpr = (node) => {
    const nodes = filterNonAstNodes(node);
    let idx = 0;
    // skip while-keyword
    idx++;
    const condition = buildExpr(nodes[idx++]);
    const block = buildBlock(nodes[idx++]);
    return { kind: 'while-expr', parseNode: node, condition, block };
};
export const buildForExpr = (node) => {
    const nodes = filterNonAstNodes(node);
    let idx = 0;
    // skip for-keyword
    idx++;
    const pattern = buildPattern(nodes[idx++]);
    // skip in-keyword
    idx++;
    const expr = buildExpr(nodes[idx++]);
    const block = buildBlock(nodes[idx++]);
    return { kind: 'for-expr', parseNode: node, pattern, expr, block };
};
export const buildClosureExpr = (node) => {
    const nodes = filterNonAstNodes(node);
    let idx = 0;
    const params = filterNonAstNodes(nodes[idx++])
        .filter(n => n.kind === 'param')
        .map(n => buildParam(n));
    const returnType = nodes.at(idx)?.kind === 'type-annot' ? buildType(nodes[idx++]) : undefined;
    const block = nodes[idx].kind === 'block'
        ? buildBlock(nodes[idx++])
        : { kind: 'block', parseNode: nodes[idx], statements: [buildStatement(nodes[idx++])] };
    return { kind: 'closure-expr', parseNode: node, params, block, returnType };
};
export const buildListExpr = (node) => {
    const nodes = filterNonAstNodes(node);
    const exprs = nodes.length > 0 ? nodes.filter(n => n.kind === 'expr').map(n => buildExpr(n)) : [];
    return { kind: 'list-expr', parseNode: node, exprs };
};
export const buildString = (node) => {
    assert(node.kind === 'string');
    const nodes = filterNonAstNodes(node);
    const tokens = nodes.map(buildStringPart);
    if (tokens.length === 0) {
        return { kind: 'string-literal', parseNode: node, value: '""' };
    }
    if (tokens.length === 1 && typeof tokens[0] === 'string') {
        return { kind: 'string-literal', parseNode: node, value: `"${tokens[0]}"` };
    }
    return { kind: 'string-interpolated', parseNode: node, tokens };
};
export const buildStringPart = (node) => {
    const n = filterNonAstNodes(node)[0];
    if (n.kind === 'string-part') {
        return n.value;
    }
    else {
        return buildExpr(n);
    }
};
export const buildChar = (node) => {
    return { kind: 'char-literal', parseNode: node, value: node.value };
};
export const buildBool = (node) => {
    return { kind: 'bool-literal', parseNode: node, value: node.value };
};
export const buildIdentifier = (node) => {
    const names = node.nodes.filter(n => nameLikeTokens.includes(n.kind)).map(buildName);
    const typeArgsNode = filterNonAstNodes(node).find(n => n.kind === 'type-args');
    const typeArgs = typeArgsNode ? filterNonAstNodes(typeArgsNode).map(buildType) : [];
    return { kind: 'identifier', parseNode: node, names, typeArgs: typeArgs };
};
export const buildName = (node) => {
    return { kind: 'name', parseNode: node, value: node.value };
};
//# sourceMappingURL=operand.js.map